//Swiper
let mySwiper = document.querySelectorAll(".mobile-swiper");

mySwiper.forEach(function (item) {
  var swiper = new Swiper(item, {
    preloadImages: false,
    lazy: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});

//ATC Appear
let mobileATCAppear = function () {
  if (window.pageYOffset > 58) {
    document.querySelectorAll(".mobile-atc")[0].classList.add("show");
  } else {
    document.querySelectorAll(".mobile-atc")[0].classList.remove("show");
  }
};

mobileATCAppear();

window.addEventListener("scroll", function () {
  mobileATCAppear();
});

//Remove Empty Colors
let singleColor = document.querySelectorAll(".single-color");

singleColor.forEach(function (item) {
  if (item.dataset.handle == "") {
    item.style.display = "none";
  }
});

//Dropdowns
let dropWrap = document.querySelectorAll(".atc-options");

let sizeParent = document.querySelectorAll(".select-size");
let colorParent = document.querySelectorAll(".select-color");

let sizeDropBtn = document.querySelectorAll(".size-drop-btn");
let colorDropBtn = document.querySelectorAll(".color-drop-btn");

let sizeDropDown = document.querySelectorAll(".size-dropdown");
let colorDropDown = document.querySelectorAll(".colors-dropdown");

let multiColorCheck = document.querySelectorAll(".colors-dropdown")[0];

if (multiColorCheck) {
  multiColorCheck = multiColorCheck.dataset.limit;
}

sizeDropBtn.forEach(function (item) {
  item.addEventListener("click", function (event) {
    event.preventDefault();
    item.classList.toggle("open");

    colorParent.forEach(function (item) {
      item.classList.remove("expand");
    });

    sizeParent.forEach(function (item) {
      item.classList.add("expand");
    });

    dropWrap.forEach(function (item) {
      item.classList.toggle("highlight");
    });

    colorDropDown.forEach(function (jtem) {
      jtem.classList.remove("open");
    });

    sizeDropDown.forEach(function (jtem) {
      jtem.classList.toggle("open");
    });
  });
});

colorDropBtn.forEach(function (item) {
  if (multiColorCheck == "single") {
    item.classList.add("single");
  }

  item.addEventListener("click", function (event) {
    event.preventDefault();
    item.classList.toggle("open");

    sizeParent.forEach(function (item) {
      item.classList.remove("expand");
    });

    colorParent.forEach(function (item) {
      item.classList.add("expand");
    });

    dropWrap.forEach(function (item) {
      item.classList.toggle("highlight");
    });

    sizeDropDown.forEach(function (jtem) {
      jtem.classList.remove("open");
    });

    colorDropDown.forEach(function (jtem) {
      jtem.classList.toggle("open");
    });
  });
});

//Move Details and Size to Accordion Section
let acDetails = document.querySelector(".description .ac-details");
let acSize = document.querySelector(".description .ac-size");

let detailsBlock = document.querySelectorAll(".acc-block-details");
let sizeBlock = document.querySelectorAll(".acc-block-size");

//console.log(detailsBlock.length + " " + sizeBlock.length);

if (detailsBlock.length > 0) {
  if (acDetails) {
    detailsBlock.forEach(function (item) {
      item.appendChild(acDetails.cloneNode(true));
    });
  }
}

if (sizeBlock.length > 0) {
  if (acSize) {
    sizeBlock.forEach(function (item) {
      item.appendChild(acSize.cloneNode(true));
    });
  }
}

//Accordions
let accBlocks = document.querySelectorAll(".acc-con");

accBlocks.forEach(function (item, i) {
  let btn = item.querySelector(".acc-btn");
  //let block = item.querySelector('.acc-block');

  let closeBlock = function (i) {
    accBlocks.forEach(function (item, j) {
      if (i != j) {
        item.classList.remove("active");
      }
    });
  };

  btn.addEventListener("click", function (event) {
    event.preventDefault();
    closeBlock(i);
    item.classList.toggle("active");
  });
});

//Size Guide Button and Tables
let sizeGuideBtn = document.querySelectorAll(".size-guide-btn");
let sizeGuideTable = document.querySelector("#size-guide-wrap");

if(sizeGuideBtn.length > 0){
  sizeGuideBtn.forEach(function(item){
    item.addEventListener("click", function(event){
      event.preventDefault();
      sizeGuideTable.classList.add("active");
    });
  });
}

//Add To Cart - Button
let atcBtn = document.querySelectorAll(".product-btn");
let atcForm = document.querySelector('#atc-form');

atcBtn.forEach(function (item) {
  item.addEventListener("click", function (event) {
    let form = document.querySelector("#atc-form");
    let theFunction = item.dataset.function;
    if (item.classList.contains("disabled")) {
      event.preventDefault();
      //console.log('disabled button');
    } else {
      event.preventDefault();
      //console.log("add to cart button");
      if (theFunction == "atc") {
        event.preventDefault();
        if(item.dataset.preOrder){
          coATC(item.dataset.variantId, item.dataset.preOrder, form);
          console.log(item.dataset.preOrder);
        } else {
          coATC(item.dataset.variantId, item.dataset.returnPolicy, form);
          console.log(item.dataset.preOrder);
        }
      } else if (theFunction == "inquire") {
      } else if (theFunction == "sold-out") {
        event.preventDefault();
      } else {
        event.preventDefault();
        console.log(item.dataset.size);
        document.querySelector("#notify-size").innerText = item.dataset.size;
        document.querySelector("#product-notify").classList.add("active");
      }
    }
  });
});

//Add To Cart - Options
let sizeOptions = document.querySelectorAll(".size-options");
//console.log(sizeOptions.length);

sizeOptions.forEach(function (ktem, k) {
  let links = ktem.querySelectorAll("a");
  links.forEach(function (item) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      let qty = item.dataset.quantity;
      let size = item.dataset.name;
      let variantId = item.dataset.value;
      let preOrder = item.dataset.preOrder;

      colorParent.forEach(function (item) {
        item.classList.remove("expand");
      });

      sizeParent.forEach(function (item) {
        item.classList.remove("expand");
      });

      dropWrap.forEach(function (item) {
        item.classList.remove("highlight");
      });

      sizeDropBtn.forEach(function (jtem) {
        jtem.innerText = size;
      });

      sizeDropDown.forEach(function (jtem) {
        jtem.classList.remove("open");
      });

      if (qty > 0) {
        atcBtn.forEach(function (jtem) {
          jtem.dataset.variantId = variantId;
          jtem.dataset.size = size;
          jtem.dataset.function = "atc";
          jtem.innerText = "Add To Bag";
          jtem.classList.remove("disabled");
        });
        atcForm.querySelector('input[name="id"]').value = variantId;
      } else {
        if(preOrder == "continue"){
          atcBtn.forEach(function (jtem) {
            jtem.dataset.variantId = variantId;
            jtem.dataset.size = size;
            jtem.dataset.function = "atc";
            jtem.innerText = "Pre-Order";
            jtem.classList.remove("disabled");
          });
          atcForm.querySelector('input[name="id"]').value = variantId;
        } else {
          let setNotifyBtn = document.querySelector("#send-notify-info");
          atcBtn.forEach(function (jtem) {
            setNotifyBtn.dataset.variantId = variantId;
            jtem.dataset.variantId = variantId;
            jtem.dataset.size = size;
            jtem.dataset.function = "notify";
            jtem.innerText = "Notify Me When Available";
            jtem.classList.remove("disabled");
          });
        }
      }
    });
  });
});

//Add To Cart - Cart Value
let coATC = function(theID, returnPolicy, form){
  var formdata = false;
  if (form) {
    form.querySelector('input[name="id"]').value = parseInt(theID);
    if (window.FormData) {
      formdata = new FormData(form);
    }
  }

  let intID = parseInt(theID);

  data = {
    id: intID,
    quantity: 1,
    // properties: {
    //   'Return Policy': returnPolicy
    // }
  };

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: formdata ? formdata : data,
    contentType: false,
    processData: false,
    dataType: "json",
    success: function () {
      document.querySelector("#side-cart").classList.add("active");
      displayCart();
    },
  });

  // jQuery.ajax({
  //   type: "POST",
  //   url: "/cart/add.js",
  //   data: data,
  //   dataType: "json",
  //   success: function () {
  //     document.querySelector('#side-cart').classList.add('active');
  //     displayCart();
  //   },
  // });

  // var xhr = new XMLHttpRequest();
  // xhr.open("POST", "/cart/add.js", true);
  // xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

  // xhr.onload = function () {
  //   if (xhr.status >= 200 && xhr.status < 400) {
  //     document.querySelector('#side-cart').classList.add('active');
  //     displayCart();
  //   }
  // };
}

//Klaviyo Product Notification
let submitNotifyBtn = document.querySelector("#send-notify-info");

submitNotifyBtn.addEventListener("click", function () {
  let notifyEmail = document.querySelector("#notify-user-email").value;
  let currentProducID = submitNotifyBtn.dataset.productId;
  let currentVariantID = submitNotifyBtn.dataset.variantId;
  let outgoingList = "TV2XqE"; //Back in stock list

  if (notifyEmail != "") {
    fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
      method: "POST",
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (data) {
        console.log(data);
      })
      .catch(function (error) {
        console.warn("Something went wrong.", error);
      });
    $.ajax({
      type: "POST",
      url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
      data: {
        a: "YB3duh",
        email: notifyEmail,
        variant: currentVariantID,
        product: currentProducID, // Product must be present in Klaviyo catalog to record event.
        platform: "shopify",
        subscribe_for_newsletter: true, // Optional with "g". Defaults to false if omitted.
        g: outgoingList, // Optional with "subscribe_for_newsletter".
      },
      success: function (response) {
        console.log(response);
        document.querySelector("#product-notify .error").classList.add("hide");
        document.querySelector("#product-notify .before").classList.add("hide");
        document.querySelector("#product-notify .after").classList.remove("hide");
      },
    });
  } else {
    document.querySelector("#product-notify .error").classList.remove("hide");
  }
});

//Image Zoom
let gallery = document.querySelector(".product-pg");
let galleryLinks = gallery.querySelectorAll(".gallery .img-zoom");

galleryLinks.forEach(function (item, i) {
  item.addEventListener("click", function (event) {
    event.preventDefault();
    gallery.classList.toggle("zoom");
    item.scrollIntoView();
    //let image = item.querySelector("img").src;
  });
});

//Single Variant
let singleVariant = document.querySelector("#no-variant");

if (singleVariant) {
  atcBtn.forEach(function (item) {
    item.classList.remove("disabled");
    item.dataset.variantId = singleVariant.dataset.singleVariant;
  });
}


//Member button
let memberBtn = document.querySelector(".upsell a");
if (memberBtn) {
  memberBtn.addEventListener("click", function (event) {
    document.querySelector(".upsell a .circle").classList.add("checked");
  });
}


//Extra
let extraBtn = document.querySelectorAll('.extra-btn');
let extraCon = document.querySelectorAll('.extra .collection-con');
if(extraBtn){
  extraBtn.forEach(function(item, i){
    item.addEventListener('click', function(event){
      event.preventDefault();
      if (i == 0) {
        extraBtn[1].classList.remove("active");
        extraCon[1].classList.remove("active");
        extraBtn[0].classList.add('active');
        extraCon[0].classList.add("active");
      } else {
        extraBtn[0].classList.remove("active");
        extraCon[0].classList.remove("active");
        extraBtn[1].classList.add("active");
        extraCon[1].classList.add("active");
      }
    });
  });
}

//Set Mobile ATC
var swiper = new Swiper('.ultra-wide', {
  //preloadImages: false,
  //loop: true,
  slidesPerView: 1.5,
  spaceBetween: 2,
  freeMode: true,
  breakpoints: {
    650: {
      slidesPerView: 2.5,
    },
    1280: {
      slidesPerView: 3.5,
    }
  },
});

/*


Recently Viewed


*/
document.addEventListener("DOMContentLoaded", function() {
  //const productHandle = "{{ product.handle }}";
  const productHandle = document.querySelector(".product-pg main .top").dataset.handle;
  //console.log(productHandle);

  let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

  recentlyViewed = recentlyViewed.filter(handle => handle !== productHandle);

  recentlyViewed.unshift(productHandle);

  if (recentlyViewed.length > 5) {
    recentlyViewed.pop();
  }

  localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
});

document.addEventListener("DOMContentLoaded", async function() {
	let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
	//console.log(recentlyViewed);

	if (recentlyViewed.length > 0) {
		const productsData = await Promise.all(recentlyViewed.map(handle => {
			return fetch(`/products/${handle}.js`)
				.then(response => response.json())
				.catch(error => console.error('Error fetching product data:', error));
		}));

		const container = document.getElementById('recently-viewed-products');

		productsData.forEach(product => {
			//console.log(product);
			if (product) {
				let cleanedTitle = product.title.split(" - ")[0];

				let formattedPrice = Shopify.formatMoney(product.price);
				formattedPrice = formattedPrice.replace(/(\.\d{2})$/, '');

				let formattedCompareAtPrice = null;
				if (product.compare_at_price && product.compare_at_price > product.price) {
					formattedCompareAtPrice = Shopify.formatMoney(product.compare_at_price);
					formattedCompareAtPrice = formattedCompareAtPrice.replace(/(\.\d{2})$/, '');
				}

				const productHTML = `
            <div class="swiper-slide">
              <div class="product">
                <div class="gallery-swiper">
                  <div class="swiper-wrapper">
                    <a href="/products/${product.handle}">
                      <img src="${product.images[0]}" alt="${product.title}" />
                    </a>
                  </div>
              </div>
              <div class="details">
                <div class="top">
                  <a href="/products/${product.handle}" class="title">${cleanedTitle}</a>
                  <a href="/products/${product.handle}" class="price">${formattedCompareAtPrice ? `<s>${formattedCompareAtPrice}</s>` : formattedPrice}</a>
                </div>

                ${formattedCompareAtPrice ? `
                <div class="bottom">
                  <div class="lefto"></div>
                  <div class="righto">
                    <span class="sale-price">
                      ${formattedPrice}
                    </span>
                  </div>
                </div>
                ` : ''}

            </div>
          `;
				container.innerHTML += productHTML;
			}
		});
	} else {
		document.getElementById('rv-heading').style.display = 'none';
		document.getElementById('rv-con').style.display = 'none';
	}
});